module.exports = __webpack_public_path__ + "static/img/labour-9.3fd6209.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-9.png
// module id = iS2Z
// module chunks = 1